module.exports = __webpack_public_path__ + "static/media/correctivo_amarillo.653e4dd1.svg";